import { useQuery } from '@tanstack/react-query';
import { getAvailableBundlesPropertyBundlesGetOptions } from '@/client/@tanstack/react-query.gen';

/**
 * Hook for fetching available property bundles
 * Handles bundle selection and credit requirements for house creation
 */
export const usePropertyBundles = () => {
	const {
		data: bundlesResponse,
		isLoading,
		error,
	} = useQuery({
		...getAvailableBundlesPropertyBundlesGetOptions(),
	});

	const bundles = bundlesResponse?.bundles ?? [];

	const BUNDLE_PROPERTY_ONE_OFF_NAME = 'bundle-one-off-property';
	const BUNDLE_PROFESSIONAL_ID = 'bundle-professional';

	const getOneOffPropertyBundle = () => {
		// return bundles.find(bundle => bundle.id === 'bundle-individual');
		return bundles.find((bundle) => bundle.id === BUNDLE_PROPERTY_ONE_OFF_NAME);
	};

	const getBundleById = (bundleId: string) => {
		return bundles.find((bundle) => bundle.id === bundleId);
	};

	const getProfessionalBundle = () => bundles.find((bundle) => bundle.id === BUNDLE_PROFESSIONAL_ID);

	return {
		bundles,
		isLoading,
		error,
		getBundleById,
		getOneOffPropertyBundle,
		getProfessionalBundle,
	};
};
